@if ({}; as STATE) {
  <section class="forgot-password-page">
    <auth-wrapper [title]="title" [description]="description">
      <forgot-password-form></forgot-password-form>
    </auth-wrapper>
  </section>
}
